import { ReconciliationCommentary, RevisionType } from '@aloft/toolkit-shared';

export type PreviousComparableCommentary = {
  revisionType: RevisionType;
  commentary: string;
};

type PreviousHistory = NonNullable<
  ReconciliationCommentary['previousAlternativeComparablesCommentaries']
>;

const normalizeAddress = (address: string) => address.trim().toLowerCase();

const getOrderedHistories = (histories: PreviousHistory | undefined) =>
  [...(histories ?? [])]
    .map((history) => ({
      revisionType: (history.revisionType ?? 'revision') as RevisionType,
      comparables: history.comparables.filter(({ commentary }) => commentary.trim().length > 0),
    }))
    .filter(({ comparables }) => comparables.length > 0)
    .reverse();

export const getPreviousCommentariesForAddress = (
  histories: PreviousHistory | undefined,
  address: string,
): PreviousComparableCommentary[] => {
  const normalizedAddress = normalizeAddress(address);
  return getOrderedHistories(histories).flatMap(({ revisionType, comparables }) =>
    comparables
      .filter((comparable) => normalizeAddress(comparable.address) === normalizedAddress)
      .map(({ commentary }) => ({ revisionType, commentary })),
  );
};

export const getMostRecentPreviousCommentaryForAddress = (
  histories: PreviousHistory | undefined,
  address: string,
): string => {
  const previousCommentaries = getPreviousCommentariesForAddress(histories, address);
  return previousCommentaries.at(-1)?.commentary ?? '';
};

export const getMostRecentPreviousCommentaryForComparable = (
  histories: PreviousHistory | undefined,
  address: string,
  index: number,
): string => {
  const byAddress = getMostRecentPreviousCommentaryForAddress(histories, address);
  if (byAddress.trim()) return byAddress;
  return histories?.[0]?.comparables[index]?.commentary ?? '';
};
